import { render, staticRenderFns } from "./ProtegerNinos.vue?vue&type=template&id=135db47c&scoped=true&"
import script from "./ProtegerNinos.vue?vue&type=script&lang=js&"
export * from "./ProtegerNinos.vue?vue&type=script&lang=js&"
import style0 from "./ProtegerNinos.vue?vue&type=style&index=0&id=135db47c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135db47c",
  null
  
)

export default component.exports